export const TABS_UNREGISTERED_EXITS = {

    CONTRACTORS: {
        INDEX: 0,
        TRANS: "contractors",
    },
    EQUIPMENT_AND_MATERIAL: {
        INDEX: 1,
        TRANS: "equipment_and_material",
    },
}

export const MODEL_CONTEXT_UNREGISTERED_EXIT = {
    tabIndex: null,
    modalDetails: false,
}
